import type { RxJsonSchema } from 'rxdb';
import type { DeficiencyActionedList } from './deficiencyActionedList.types';

export const deficiencyActionedListSchema: RxJsonSchema<DeficiencyActionedList> = {
  type: 'object',
  version: 0,
  description: 'describes active deficiency lists',
  primaryKey: 'pkDeficiencyUUID',
  properties: {
    pkDeficiencyUUID: { type: 'string', maxLength: 36 },
    assetId: { type: ['number', 'null'] },
    assetName: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    workPackageId: { type: ['number', 'null'] },
    workOrderId: { type: ['string', 'null'] },
    inspectionStatus: { type: ['number', 'null'] },
    componentFailureId: { type: ['string', 'null'] },
    workRequestId: { type: ['string', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    capMapProjectId: { type: ['string', 'null'] },
    capMapTaskId: { type: ['string', 'null'] },
    fkComponentRemovalCategory: { type: ['number', 'null'] },
    componentRemovalCategory: { type: ['string', 'null'] },
    componentRemovalComments: { type: ['string', 'null'] },
    workOrderStatus: { type: ['string', 'null'] },
    workRequestStatus: { type: ['string', 'null'] },
    workPackageStatus: { type: ['string', 'null'] },
    componentFailureStatus: { type: ['number', 'null'] },
    tMAppliedDate: { type: ['string', 'null'] },
    tMClosureDate: { type: ['string', 'null'] },
  },
};
